module.exports = __webpack_public_path__ + "img/op_img-card-3.24de988.jpg";